import React, {ClipboardEvent, Component} from 'react';

import {isPromise} from '../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {reportToBugsnag} from '../../../../srcCommon/services/bugsnag/bugsnag';
import {getFilesFromDataTransfer} from '../../../helpers/clipboardHelpers';
import {getFilesFromClipboardAsync} from '../../../services/electron/electronBridgeOutbound';

/*
 * Props.
 */

interface AttachmentsPasteTargetProps {
  className?: string;
  onPasteFile: AttachmentsPasteTargetPasteFileHandler;
}

type AttachmentsPasteTargetPasteFileHandler = (file: File) => void;

/*
 * Component.
 */

export class AttachmentsPasteTarget extends Component<AttachmentsPasteTargetProps> {
  private readonly onPaste = (event: ClipboardEvent) => {
    const onPasteFiles = (files: File[]) => files.forEach((f) => this.props.onPasteFile(f));

    // If in Electron, attempt to get files natively, but use the event's files if none are
    // returned by Electron. This allows us to reuse Chrome's handling of image formats.
    const filesFromDataTransfer = getFilesFromDataTransfer(event.clipboardData);
    const filesFromElectronPromise = getFilesFromClipboardAsync();
    if (isPromise(filesFromElectronPromise)) {
      event.stopPropagation();
      event.preventDefault();

      filesFromElectronPromise
        .then((filesFromElectron) =>
          onPasteFiles(filesFromElectron.length ? filesFromElectron : filesFromDataTransfer),
        )
        .catch(reportToBugsnag);
      return;
    }

    if (!filesFromDataTransfer.length) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    onPasteFiles(filesFromDataTransfer);
  };

  render() {
    return (
      <div className={this.props.className} onPaste={this.onPaste}>
        {this.props.children}
      </div>
    );
  }
}
